import {
  FETCH_TOPICS_REQUEST,
  FETCH_TOPICS_SUCCESS,
  FETCH_TOPICS_FAILURE,
  SELECT_TOPIC,
  FOCUS_TOPIC,
  FOCUS_TOPIC_POSITION,
  DISMISS_ERROR,
} from '../actions/topics'

const INITIAL_STATE = {
  isReady: false,
  hasError: false,
  errorMessage: '',
  previousId: -1,
  selectedTopicId: -1,
  focusedTopicId: -1,
  focusedTopicPosition: -1,
  topics: [],
  topicsById: {},
}

const topicsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_TOPICS_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: '',
      }
    case FETCH_TOPICS_SUCCESS:
      let topics = []
      let topicsById = {}
      action.payload.topics.forEach(topic => {
        topicsById[topic.id] = topic
        topics.push(topic.id)
      })
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
        topics: topics,
        topicsById: topicsById,
        focusedTopicId: topics.length > 1 ? topics[0] : -1,
        focusedTopicPosition: topics.length > 1 ? Object.keys(topics)[0] : -1,
        previousId: topics.length > 1 ? topics[0] : -1,
      }

    case FOCUS_TOPIC:
      return {
        ...state,
        focusedTopicId: action.payload.id,
        previousId: state.focusedTopicId !== -1 ? state.focusedTopicId : state.previousId,
      }
    case FOCUS_TOPIC_POSITION:
      return {
        ...state,
        focusedTopicPosition: action.payload.position,
      }
    case FETCH_TOPICS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to load the topics',
      }
    case SELECT_TOPIC:
      return {
        ...state,
        selectedTopicId: action.payload.id,
        focusedTopicId: action.payload.id,
        previousId: action.payload.id,
      }
    case DISMISS_ERROR:
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
      }
    default:
      return state
  }
}

export default topicsReducer
